import { useEffect } from 'react'
import { useNavigate } from 'react-router'

/**
 * Turns clicks on plain `<a href>` links to pages of the site into client-side
 * navigation. The library components render plain links; this keeps them from
 * reloading the whole app. New-tab clicks, downloads and external links are
 * left to the browser.
 */
export function useInternalLinks(): void {
  const navigate = useNavigate()

  useEffect(() => {
    function onClick(event: MouseEvent) {
      if (event.defaultPrevented || event.button !== 0) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
      const anchor = (event.target as Element | null)?.closest?.('a')
      if (!anchor || anchor.target || anchor.hasAttribute('download')) return
      const url = new URL(anchor.href, window.location.href)
      if (url.origin !== window.location.origin) return
      event.preventDefault()
      navigate(url.pathname + url.search + url.hash)
    }
    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [navigate])
}
